export class ProductDto {
    constructor(public Id: number,
                public Name: string,
                public NameTranslated: string,
                public Image: string,
                public ConfigurationId: number) {
    }
}